import React from "react";
import Button from "../button/button";
import classes from "./card.module.css";
import { getImageUrl } from "../../../utils/imageUrl";

const Card = ({ item, withList, whiteBackground, setShowDetails, setIsNew, click, button }) => {
    const showDetailsHandler = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setShowDetails(true);
        setIsNew(item.status === 'Finished' ? false : true);
    }
    return (
        <div className={[classes.Container, withList && classes.IncreaseContainerHeight].join(" ")}>
            <div className={classes.ImgContainer}>
                <img src={getImageUrl(item.image)} alt={item.title} />
            </div>
            <h3>{item.title}</h3>
            {item.description && <p>{item.description}</p>}
            {item.date && <div>
                <span>Date: </span>
                <span>{item.date}</span>
            </div>}
            {item.playersPerTeam && <div>
                <span>Players Per Team: </span>
                <span>{item.playersPerTeam}</span>
            </div>}
            {item.ageGroup && <div>
                <span>Age Group: </span>
                <span>{item.ageGroup}</span>
            </div>}
            {item.gender && <div>
                <span>Gender: </span>
                <span>{item.gender}</span>
            </div>}
            {item.joinedTeams && <div>
                <span>Joined Teams: </span>
                <span>{item.joinedTeams}</span>
            </div>}
            {item.status && <div>
                <span>Status: </span>
                <span>{item.status}</span>
            </div>}
            {item.registrationType && <div>
                <span>Registration Type: </span>
                <span>{item.registrationType}</span>
            </div>}
            {item.registrationFees && <div>
                <span>Registration Fees: </span>
                <span className={classes.RegistrationFees}>{item.registrationFees}</span>
                <span> / Team</span>
            </div>}
            <Button content={button} whiteBackground={whiteBackground} onClick={click ? click : showDetailsHandler} />
        </div>
    )
}

export default Card;